import { Grid } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

export const TableWrapper = withTheme(
    styled(Grid)`
        width: 100%;
    `,
);
